import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@/stores/hooks';
import { RootState } from '@/stores/store';
import { getLastClientId, getSessionClientId } from '@/utils/lastClient';
import { checkAuthentication } from '@/utils/helper';
import encryptDecrypt from '@/utils/encryptDecrypt';

const RootRedirect = () => {
  const navigate = useNavigate();
  const activeClientId = useAppSelector((s: RootState) => s.activeClient.id);

  useEffect(() => {
    if (!checkAuthentication()) return;

    const clientId =
      activeClientId ?? getSessionClientId() ?? getLastClientId();

    if (clientId && clientId.trim().length > 0) {
      const encryptedId = encryptDecrypt.encryptClientId(clientId);
      navigate(`/${encryptedId}/`, { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [activeClientId]);

  return null;
};

export default RootRedirect;
